import { IconTypes } from "~/components/Icon/types";
import { getValueByAssetClassID } from "./getValueByAssetClass";
import {
    ASSET_CLASS_PAGES_TO_ICON,
    ASSET_CLASS_PAGE_TO_ROUTE,
} from "~/modules/asset_classes/metadata";

// // // //

export function getAssetClassLinkMetadata(assetClassID: number | null): {
    href: string | null;
    icon: IconTypes;
    label: string | null;
} {
    // Handle edge case if assetClassID is null (just here for type-safety)
    if (assetClassID == null) {
        return {
            href: null,
            icon: IconTypes.Coins,
            label: null,
        };
    }

    const href = getValueByAssetClassID({
        assetClassID: assetClassID,
        values: {
            treasury: ASSET_CLASS_PAGE_TO_ROUTE.treasuries,
            commodity: ASSET_CLASS_PAGE_TO_ROUTE.commodities,
            stablecoin: ASSET_CLASS_PAGE_TO_ROUTE.stablecoins,
            stocks: ASSET_CLASS_PAGE_TO_ROUTE.stocks,
            non_us_government_debt: ASSET_CLASS_PAGE_TO_ROUTE.government_bonds,
            municipal_bonds: ASSET_CLASS_PAGE_TO_ROUTE.credit,
            corporate_credit: ASSET_CLASS_PAGE_TO_ROUTE.credit,
            real_estate: ASSET_CLASS_PAGE_TO_ROUTE.real_estate,
            diversified_credit: ASSET_CLASS_PAGE_TO_ROUTE.credit,
            asset_backed_credit: ASSET_CLASS_PAGE_TO_ROUTE.credit,
            specialty_finance: ASSET_CLASS_PAGE_TO_ROUTE.credit,
            active_strategies: ASSET_CLASS_PAGE_TO_ROUTE.active_strategies,
            private_equity: ASSET_CLASS_PAGE_TO_ROUTE.pe_vc,
            venture_capital: ASSET_CLASS_PAGE_TO_ROUTE.pe_vc,
            repurchase_agreements: null,
        },
        fallbackValue: null,
    });

    const icon = getValueByAssetClassID({
        assetClassID: assetClassID,
        values: {
            treasury: ASSET_CLASS_PAGES_TO_ICON.treasuries,
            commodity: ASSET_CLASS_PAGES_TO_ICON.commodities,
            stablecoin: ASSET_CLASS_PAGES_TO_ICON.stablecoins,
            stocks: ASSET_CLASS_PAGES_TO_ICON.stocks,
            non_us_government_debt: ASSET_CLASS_PAGES_TO_ICON.government_bonds,
            municipal_bonds: ASSET_CLASS_PAGES_TO_ICON.credit,
            corporate_credit: ASSET_CLASS_PAGES_TO_ICON.credit,
            real_estate: ASSET_CLASS_PAGES_TO_ICON.real_estate,
            diversified_credit: ASSET_CLASS_PAGES_TO_ICON.credit,
            active_strategies: ASSET_CLASS_PAGES_TO_ICON.active_strategies,
            private_equity: ASSET_CLASS_PAGES_TO_ICON.pe_vc,
            venture_capital: ASSET_CLASS_PAGES_TO_ICON.pe_vc,
            repurchase_agreements: ASSET_CLASS_PAGES_TO_ICON.credit,
            asset_backed_credit: ASSET_CLASS_PAGES_TO_ICON.credit,
            specialty_finance: ASSET_CLASS_PAGES_TO_ICON.credit,
        },
        fallbackValue: IconTypes.Coins,
    });

    const label = getValueByAssetClassID({
        assetClassID: assetClassID,
        values: {
            treasury: "U.S. Treasury Funds",
            commodity: "Commodities",
            stablecoin: "Stablecoins",
            stocks: "Stocks",
            non_us_government_debt: "Non-U.S. Government Debt",
            municipal_bonds: "Credit",
            corporate_credit: "Corporate Credit",
            real_estate: "Real Estate",
            diversified_credit: "Diversified Credit",
            active_strategies: "Active Strategies",
            private_equity: "Private Equity",
            venture_capital: "Venture Capital",
            repurchase_agreements: "Repurchase Agreements",
            asset_backed_credit: "Asset-Backed Credit",
            specialty_finance: "Specialty Finance",
        },
        fallbackValue: null,
    });

    return {
        href,
        icon,
        label,
    };
}
